import { useState } from 'react';

const useCounter = (limit: number, onTarget?: () => void) => {
  const [counter, setCounter] = useState(0);

  const inc = () => {
    const newVal = counter + 1;
    setCounter(newVal);
    if (newVal === limit) {
      onTarget?.();
      setCounter(0);
    }
  };

  const dec = () => {
    const newVal = counter - 1;
    setCounter(newVal);
    if (newVal === limit) {
      onTarget?.();
      setCounter(0);
    }
  };

  return [counter, inc, dec] as const;
};

export default useCounter;
